var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"block links"},_vm._l((_vm.data),function(item,index){return _c('a',{key:index,staticClass:"link",attrs:{"href":item.link,"target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/images/icon_link.svg")}}),_c('p',{staticClass:"link__name"},[_vm._v(_vm._s(item.name))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }